module.exports = __webpack_public_path__ + "static/media/signature.d59b0c04.jpg";